module.exports = __webpack_public_path__ + "img/horizontal_3_1_9006.01bd13ec.png";